import { useCallback, useEffect, useRef } from "react";
import type { SlateValue } from "@components/mainInterface/chat/slate/slateTypes";
import {
    isSlateValueEmpty,
    serializeSlateValue,
} from "@components/mainInterface/chat/slate/slateHelpers";

type SetFieldValue = (field: string, value: string | null) => void;

export const useInitialMessageHandler = (setFieldValue: SetFieldValue) => {
    const setFieldValueRef = useRef(setFieldValue);
    useEffect(() => {
        setFieldValueRef.current = setFieldValue;
    }, [setFieldValue]);

    return useCallback((value: SlateValue) => {
        setFieldValueRef.current(
            "initialMessage",
            isSlateValueEmpty(value) ? null : serializeSlateValue(value),
        );
    }, []);
};
